import "./style.scss";
import BubbleVideo from "../BubbleVideo";

export default function BadgeCard({ children }) {
  return (
    <div className="empty-list-placeholder-component">
      <BubbleVideo />
      <div className="card">{children}</div>
    </div>
  );
}
